import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesProduccion() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Producción", items: [
      { label: "Ordenes de Produccion", icon: "fas fa-file-alt", color: "#7c3aed", href: "/ListadoOrdenesCorte", enabled: !!(user.menu_produccion) },
      { label: "Cortes", icon: "fas fa-cut", color: "#7c3aed", href: "/ListadoCortes", enabled: !!(user.menu_produccion) },
      { label: "Procesos Pendientes Recibir", icon: "fa-solid fa-hourglass-half", color: "#7c3aed", href: "/CortesPendientesRecibir", enabled: !!(user.menu_produccion) },
      { label: "Seguimiento Produccion", icon: "fas fa-industry", color: "#7c3aed", href: "/SeguimientoProduccion", enabled: !!(user.menu_produccion) },
    ]},
    { section: "Producto Terminado", items: [
      { label: "Ordenes de Compra", icon: "fas fa-tshirt", color: "#2563eb", href: "/ListadoOrdenesCorteExterno", enabled: !!(user.menu_produccion) },
      { label: "Recepción Compras", icon: "fas fa-cart-plus", color: "#2563eb", href: "/ListadoComprasDirectas", enabled: !!(user.menu_produccion && user.menu_compras) },
      { label: "Ordenes Compra Producto Terminado", icon: "fas fa-file-alt", color: "#2563eb", href: "/ReporteOrdenesCompraPT", enabled: !!(user.menu_produccion) },
    ]},
    { section: "Reportes", items: [
      { label: "Reporte Cortes", icon: "fa-solid fa-square-poll-horizontal", color: "#0d9488", href: "/ListadoArticulosCortes", enabled: !!(user.menu_produccion) },
      { label: "Reporte Costos Cortes", icon: "fas fa-dollar-sign", color: "#0d9488", href: "/ReporteCostosCortes", enabled: !!(user.menu_produccion && user.menu_compras) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Producción"
      descripcion="Órdenes, cortes y procesos"
      icono="fas fa-cut"
      color="#7c3aed"
      secciones={secciones}
    />
  );
}

export default BotonesProduccion;
